'use client'

import React, { useEffect, useRef, useState } from 'react'
import style from "./styles/common.module.css"
import { Link, useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom';

import {
    useConnectModal,
    useAccountModal,
    useChainModal,
} from "@rainbow-me/rainbowkit";
import { useAccount, useDisconnect } from 'wagmi';




export const Navbar = () => {
    const [togglenav, setToggle] = useState(false)
    const { openConnectModal } = useConnectModal();
    const { disconnectAsync } = useDisconnect()
    const { address, isConnected } = useAccount()
    const navref = useRef(null);
    const location = useLocation();
    // console.warn("currPath:", location.pathname)

    const handleClickOutside = (event) => {
        if (navref.current && !navref.current.contains(event.target)) {
            setToggle(false)
        }
    }

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside)
        }
    }, [])
    useEffect(() => {
        document.querySelector(".nav_container").style.display = "block"

    }, [location.pathname])

    return (

        <div className={style.nav_container + " nav_container"} ref={navref}>
            <nav className={style.nav + " d-flex align-items-center justify-content-between py-3 px-sm-5 px-md-3 px-lg-5 px-3"}>
                <Link to="/">
                    <div className={style.nav_logo + ' d-flex gap-2 align-items-center'}>
                        <img src="/icons/logo.svg" alt="" />
                        <span className='text-dark'>SHiELD</span>
                    </div>
                </Link>
                <div className={style.min_ui} style={{ right: togglenav ? "0" : "-100vw" }}>
                    <button className="bg-transparent border-0 d-md-none mb-4" onClick={() => setToggle(!togglenav)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>
                    <ul className={style.links + " list-unstyled d-md-flex gap-xxl-5 mb-0 gap-lg-4 gap-3 gap-md-2 px-2"}>
                        <li onClick={() => setToggle(false)}>
                            <Link to="/" className={location.pathname == "/" ? style.activelink : null} >Home</Link>
                        </li>
                        <li onClick={() => setToggle(false)}>
                            <Link to="/mint" className={location.pathname == "/mint" ? style.activelink : null} >Mint</Link>
                        </li>
                        <li onClick={() => setToggle(false)}>
                            <Link to="/redeem" className={location.pathname == "/redeem" ? style.activelink : null}>Redeem</Link>
                        </li>
                        <li onClick={() => setToggle(false)}>
                            <Link to="/farm" className={location.pathname == "/farm" ? style.activelink : null}>Farms</Link>
                        </li>
                        <li onClick={() => setToggle(false)}>
                            <Link to="/stake" className={location.pathname == "/stake" ? style.activelink : null}>Stake</Link>
                        </li>
                        <li onClick={() => setToggle(false)}>
                            <Link to="/lock" className={location.pathname == "/lock" ? style.activelink : null}>Lock</Link>
                        </li>
                        <li onClick={() => setToggle(false)}>
                            <Link to="/dashboard" className={location.pathname == "/dashboard" ? style.activelink : null}>Dashboard</Link>
                        </li>
                        {/* <li onClick={() => setToggle(false)}>
                            <Link to="/claim-reward" className={location.pathname == "/claim-reward" ? style.activelink : null}>Claim</Link>
                        </li> */}

                    </ul>
                    {
                        address ? <div className={style.ac_address + " d-flex flex-column align-items-center gap-3"}>
                            <p className={style.ac_address + ' text-center d-md-none fw-semibold mb-0'}>
                                {address.slice(0, 4) + "..." + address.slice(address.length - 4, address.length)}
                                {/* <button className="btn1 py-2 px-5 d-md-none">Connect Wallet</button> */}
                            </p>
                            <button className="btn1 d-md-none" onClick={disconnectAsync} >Disconnect Wallet</button>

                        </div> :
                            <button className="btn1 py-2 px-5 d-md-none" onClick={openConnectModal}>Connect Wallet</button>
                    }
                    <div className='position-absolute d-sm-none bottom-0 py-3' style={{ width: "calc(100% - 2rem)" }}>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className={style.f_logo + " d-flex align-items-center"}>
                                <img src="/icons/logo.svg" alt="" />
                                <span>SHiELD</span>
                            </div>
                            <div>
                                <div className={style.f_right + ' d-flex gap-2'}>
                                    <a href="https://t.me/shield_protocol" target='_blank'>
                                        <img src="/icons/tg.svg" alt="" />
                                    </a>
                                    <a href="https://shield-pro.gitbook.io/shield" target='_blank'>
                                        <img src="/icons/gitbook.svg" alt="" width="22px" />
                                    </a>
                                    <a href="https://x.com/ShieldProtocols" target='_blank'>
                                        <img src="/icons/twiter.svg" alt="" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <p className={'text-center mt-2 ' + style.f_para}>All rights reserved @2024</p>
                    </div>
                </div>
                <div>
                    {
                        address ? <div className={style.ac_address + " d-flex gap-3 gap-md-2 gap-lg-3"}>
                            <p className={'d-none d-md-block fw-semibold mb-0'}>
                                {address.slice(0, 3) + "......" + address.slice(address.length - 4, address.length)}
                            </p>
                            <button className="btn1 d-none d-md-block" onClick={disconnectAsync} >Disconnect Wallet</button>
                        </div> :
                            <button className="btn1 py-2 px-3 d-none d-md-block" onClick={openConnectModal}>Connect Wallet</button>
                    }
                    <button className="btn1 px-2 py-1 d-md-none" onClick={() => setToggle(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                        </svg>
                    </button>
                </div>
            </nav>
        </div>
    )
}
